'use client';

import { createPortal } from 'react-dom';
import { usePortalContainer } from '../../lib/portalContainer.js';

/**
 * Returns a function that renders floating UI (tooltips, popovers, the
 * floating account panel) in a portal: on <body>, or in the container set by
 * PortalContainerProvider (Shadow DOM embed). Inside `.sidenav` they were
 * trapped in its stacking context (z-index 40), so a page element or a modal
 * could cover them, and a CSS transform on the sidenav (mobile) broke their
 * `position: fixed`. Without a DOM (SSR) the node is returned in place.
 */
export function usePortal() {
  const container = usePortalContainer();
  return (node) => {
    if (typeof document === 'undefined' || !document.body) return node;
    return createPortal(node, container || document.body);
  };
}
